import styled from 'styled-components';
import {
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen
} from 'theme';
import { getPublicPath } from 'utils/paths';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${fontFamily('ibm')};
  font-size: ${fontSize('xl3')};
  font-weight: ${fontWeight('medium')};
  line-height: 36px;
`;

export const Intro = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: min(calc(100vw * 3 / 4), 100vh);
  background: url(${getPublicPath('/images/septiembre25/mount.jpg')}) center
    center / cover no-repeat;

  @media (max-width: ${screen('md')}) {
    background: url(${getPublicPath('/images/septiembre25/mount_small.png')})
      center center / cover no-repeat;
    height: calc(100vw * 16 / 9);
  }

  .logo {
    position: absolute;
    top: clamp(20px, 5vw, 40px);
    right: clamp(20px, 5vw, 40px);
    width: clamp(100px, 25vw, 200px);
    height: auto;
    z-index: 3;
  }

  .folder-container {
    position: relative;
    display: inline-block;
    z-index: 2;
    width: min(60%, 600px);

    @media (max-width: ${screen('md')}) {
      width: 90%;
    }

    .folder {
      display: block;
      width: 100%;
      height: auto;
      position: relative;
      z-index: 1;
    }

    .tab-1,
    .tab-2,
    .tab-3 {
      text-align: center;
      z-index: 2;
      position: absolute;
      top: 8%;
      transform: translate(-50%, -50%);
      font-size: min(1vw, 0.9rem);
      font-weight: ${fontWeight('bold')};
      white-space: nowrap;
    }
    .tab-1 {
      left: 20%;
    }
    .tab-2 {
      left: 50%;
    }
    .tab-3 {
      left: 78%;
    }

    .text {
      max-width: 80%;
      z-index: 2;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .cursor {
      z-index: 3;
      position: absolute;
      top: 70%;
      left: 90%;
      transform: translate(-50%, -50%);
      width: 80px;
      max-width: 8%;
    }
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 20%;
    background: linear-gradient(
      to bottom,
      rgba(247, 242, 223, 0) 0%,
      rgba(247, 242, 223, 0.7) 50%,
      #f7f2df 100%
    );
    z-index: 0;
    pointer-events: none;
  }
`;

export const Description = styled.div`
  background-color: #f7f2df;
  font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
  line-height: clamp(24px, 3.3vw, 36px);
  padding: 6rem clamp(20px, 8.8vw, 1000px) 6rem clamp(20px, 10vw, 1000px);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4rem;

  & > * {
    max-width: ${container('lg')};
  }
`;

export const Cows = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
  background: url(${getPublicPath('/images/septiembre25/cows.png')}) top center /
    cover no-repeat;
  padding: 8rem clamp(20px, 8.8vw, 1000px) 8rem clamp(20px, 10vw, 1000px);

  .cowsText {
    max-width: ${container('lg')};
    background-color: #d9d9d9;
    font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
    line-height: clamp(24px, 3.3vw, 36px);
    padding: clamp(20px, 5.5vw, 5rem);
  }
`;

export const FeaturedVideos = styled.div`
  width: 100%;
  background-color: #f7f2df;

  & > * {
    max-width: ${container('xl2')};
    margin: 0 auto;
  }

  .featuredVideosDesc {
    max-width: ${container('lg')};
    font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
    line-height: clamp(24px, 3.3vw, 36px);
    padding: clamp(20px, 10%, 5rem);
  }

  .videos {
    max-width: ${container('xlMax')};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 3rem;
    justify-content: center;
    align-items: center;
    padding: 0 clamp(20px, 10%, 5rem) 6rem clamp(20px, 10%, 5rem);

    @media (min-width: 768px) and (max-width: 1100px) {
      display: flex;
      & > * {
        width: 33%;
      }
    }
  }
`;
export const Survey = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  width: 100%;
  height: auto;
  background: url(${getPublicPath('/images/septiembre25/hiking_b.png')}) top
    center / cover no-repeat;
  padding-top: 8rem;

  .title {
    width: min(${container('xlMax')}, 90%);
    font-size: clamp(${fontSize('md')}, 3vw, ${fontSize('xl')});
    font-weight: ${fontWeight('black')};
    padding: 0 clamp(20px, 8.8vw, 1000px);
  }
  .questions {
    width: min(${container('xlMax')}, 90%);
    font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
    padding: 0 clamp(20px, 8.8vw, 1000px);
  }

  .surveyImage {
    width: 100%;
    height: auto;
    object-fit: cover;
    z-index: 0;
  }
`;

export const Subscribe = styled.div`
  width: 100%;
  background-color: #f7f2df;
  padding: clamp(20px, 10%, 5rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});

  & > * {
    max-width: ${container('lg')};
  }

  .description {
    margin-top: 5rem;
    font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
    margin-bottom: 1rem;
  }

  .form-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  .label {
    font-weight: bold;
  }

  .input-group {
    display: flex;
    align-items: center;
    gap: 3rem;
    width: 100%;
    justify-content: center;
  }

  .input {
    width: 55%;
    height: 3.5rem;
    padding: 0.75rem 1.25rem;
    border-radius: ${radius('lg')};
    border: none;
    background-color: #acacac;
    color: #2d2d2d;
    outline: none;
    flex-grow: 1;
    font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
    font-family: ${fontFamily('mono')};

    &::placeholder {
      color: #8c8c8c;
    }
  }

  .button {
    width: 35%;
    height: 3.5rem;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: ${radius('lg')};
    background-color: #84441c;
    color: #f7f2df;
    cursor: pointer;
    outline: none;
    white-space: nowrap;
    font-size: clamp(${fontSize('md')}, 2.2vw, ${fontSize('lg')});
    font-family: ${fontFamily('mono')};

    &:disabled {
      cursor: not-allowed;
    }
  }

  .socials {
    margin-top: 3rem;
    margin-bottom: 1rem;
    font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .icons {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      margin-top: 0.5rem;
    }

    img {
      height: 50px;
    }
  }
`;

export const UfoFooter = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  min-height: 90vh;
  width: 100%;
  background: url(${getPublicPath('/images/septiembre25/ufo.png')}) top center /
    cover no-repeat;

  font-family: ${fontFamily('mono')};
  font-weight: ${fontWeight('bold')};
  font-size: clamp(${fontSize('md')}, 3vw, ${fontSize('xl')});

  .topText {
    position: absolute;
    top: 5%;
    text-align: center;
    padding-left: clamp(20px, 5vw, 100px);
    padding-right: clamp(20px, 5vw, 100px);
  }

  .beamText {
    position: absolute;
    bottom: 20%;
  }

  .logo {
    position: absolute;
    right: clamp(12px, 3vw, 28px);
    bottom: clamp(12px, 3vw, 28px);
    width: clamp(100px, 25vw, 200px);
  }
`;
